import {makeAutoObservable} from "mobx";
import {
    ShipmentPackageListItemDto,
    ShipmentPackageListSortByDto,
    ShipmentPackageStatusDto, ShipmentProcessTypeDto, ShipmentTypeDto,
    SortTypeDto
} from "../../api/fms";
import {pageLoadingStore} from "../PageLoadingStore";
import {api, catchApi} from "../../api";

class FmsPackageOverviewStore {
    get compartment(): number | undefined {
        return this._compartment;
    }

    set compartment(value: number | undefined) {
        this._compartment = value;
    }
    get process(): ShipmentProcessTypeDto[] | undefined {
        return this._process;
    }

    set process(value: ShipmentProcessTypeDto[] | undefined) {
        this._process = value;
    }
    get shipmentType(): ShipmentTypeDto[] | undefined {
        return this._shipmentType;
    }

    set shipmentType(value: ShipmentTypeDto[] | undefined) {
        this._shipmentType = value;
    }
    get status(): ShipmentPackageStatusDto[] | undefined {
        return this._status;
    }

    set status(value: ShipmentPackageStatusDto[] | undefined) {
        this._status = value;
    }
    get sortBy(): ShipmentPackageListSortByDto | undefined {
        return this._sortBy;
    }

    set sortBy(value: ShipmentPackageListSortByDto | undefined) {
        this._sortBy = value;
    }
    get customerId(): string | undefined {
        return this._customerId;
    }

    set customerId(value: string | undefined) {
        this._customerId = value;
    }
    get toAbsolute(): string | undefined {
        return this._toAbsolute;
    }

    set toAbsolute(value: string | undefined) {
        this._toAbsolute = value;
    }
    get fromAbsolute(): string | undefined{
        return this._fromAbsolute;
    }

    set fromAbsolute(value: string | undefined) {
        this._fromAbsolute = value;
    }
    get toRelative(): string | undefined{
        return this._toRelative;
    }

    set toRelative(value: string | undefined) {
        this._toRelative = value;
    }
    get fromRelative(): string | undefined{
        return this._fromRelative;
    }

    set fromRelative(value: string | undefined) {
        this._fromRelative = value;
    }
    get q(): string | undefined{
        return this._q;
    }

    set q(value: string | undefined) {
        this._q = value;
    }
    get sortType(): SortTypeDto | undefined {
        return this._sortType;
    }

    set sortType(value: SortTypeDto | undefined) {
        this._sortType = value;
    }
    get size(): number {
        return this._size;
    }

    set size(value: number) {
        this._size = value;
    }
    get page(): number {
        return this._page;
    }

    set page(value: number) {
        this._page = value;
    }
    get pages(): number {
        return this._pages;
    }

    set pages(value: number) {
        this._pages = value;
    }
    get items(): ShipmentPackageListItemDto[] {
        return this._items;
    }

    set items(value: ShipmentPackageListItemDto[]) {
        this._items = value;
    }

    private _items: ShipmentPackageListItemDto[] = []
    private _pages: number = 0
    private _page: number = 1
    private _size: number = 25

    private _sortBy?: ShipmentPackageListSortByDto
    private _sortType?: SortTypeDto
    private _q?: string
    private _fromRelative?: string
    private _toRelative?: string
    private _fromAbsolute?: string
    private _toAbsolute?: string
    private _customerId?: string
    private _status?: ShipmentPackageStatusDto[]
    private _shipmentType?: ShipmentTypeDto[]
    private _process?: ShipmentProcessTypeDto[]
    private _compartment?: number

    constructor() {
        makeAutoObservable(this)
    }

    async load() {
        pageLoadingStore.loading = true
        const {
            page,
            size,
            sortBy,
            sortType,
            q,
            fromRelative,
            toRelative,
            fromAbsolute,
            toAbsolute,
            customerId,
            status,
            shipmentType,
            process,
            compartment
        } = this

        const result = await catchApi(async () => await api.fms.api.listPackages({
            page: page - 1,
            size,
            sortBy,
            sortType,
            q,
            fromRelative,
            toRelative,
            fromAbsolute,
            toAbsolute,
            customerId,
            status,
            shipmentType,
            process,
            compartment
        }))
        const data = result?.data
        if (data?.items) {
            this.items = data.items
            this.pages = data.totalPages || 0
        } else {
            this.items = []
            this.pages = 0
        }
        pageLoadingStore.loading = false
    }
}

const fmsPackageOverviewStore = new FmsPackageOverviewStore()

export {
    fmsPackageOverviewStore
}
